import React from "react";

export default function Main() {
  const testimonials = [
    {
      id: 1,
      name: "Beauty Expert",
    //   image: "https://c.animaapp.com/OWDlS9CO/img/rectangle-57@2x.png",
      image: "/assets/images/icons/male-icon.png",
      text: "This app makes finding the best products by ingredients effortless and reliable.",
      position: { top: "373px", left: "0" },
    },
    {
      id: 2,
      name: "Customer",
    //   image: "https://c.animaapp.com/OWDlS9CO/img/rectangle-57-1.svg",
      image: "/assets/images/icons/female-icon.png",
      text: "I saved time searching for cosmetics and actually saw my skin improve.",
      position: { top: "73px", left: "769px" },
    },
  ];

  return (
    <div className="main-container mx-auto my-0">
      {/* Desktop Layout (scales smoothly down to tablet) */}
      <div className="hidden lg:flex justify-center items-center w-full overflow-hidden font-sans">
        <div
          className="relative"
          style={{
            width: "100%",
            height: "100%",
            maxWidth: "1335px",
            aspectRatio: "1335 / 700",
            // transformOrigin: "top left",
          }}
        >
          <section className="absolute inset-0 w-full h-full">
            <div className="relative w-[1018px] h-full mx-auto mt-[27px]">
              <img
                className="absolute w-[923px] h-[522px] top-0 left-[47px]"
                alt="Beauty products and ingredients background showcasing various skincare items"
                // src="https://c.animaapp.com/OWDlS9CO/img/group-91.png"
                src="/assets/images/backgrounds/group-91.png"
              />

              <article className="absolute w-[566px] h-[290px] top-[84px] left-[105px]">
                <div className="relative w-[564px] h-[290px]">
                  <div
                    className="absolute w-[557px] h-[290px] top-0 left-0 rounded-[14px] rotate-180 blur-[18px] bg-[linear-gradient(270deg,rgba(0,0,0,0.3)_0%,rgba(0,0,0,0.5)_11%,rgba(0,0,0,0.1)_100%)]"
                    aria-hidden="true"
                  />
                  <p className="absolute w-[556px] top-0 left-2 [text-shadow:4px_7px_7px_#00000080] font-sans text-neutral-100 text-[20px] leading-normal">
                    Our app uses smart technology to recommend skincare and
                    beauty items based on their ingredients and how similar they
                    are to products you already love.
                    <br />
                    <br />
                    Behind the scenes, it learns from lots of data and
                    connections between ingredients to suggest options you'll
                    enjoy. It’s like having a beauty expert in your pocket,
                    helping you discover new favourites easily and confidently.
                  </p>
                </div>
              </article>


              <div
  style={{
    position: "relative",
    width: "100px",
    height: "100px",
    top: "373px",
    left: "802px",
    backgroundImage: "url('/assets/images/backgrounds/cosmelytix_mini_logo_white.png')",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundPosition: "center",
    zIndex: 10,       
  }}

  

/>
              {/* <div
                className="absolute w-[600px] h-[600px] top-[373px] left-[802px] bg-[url(/assets/images/backgrounds/cosmelytix_mini_logo_white.png)] bg-no-repeat bg-[-20%_-20%]"
                aria-hidden="true"
              /> */}

              {testimonials.map((testimonial) => (
                <article
                  key={testimonial.id}
                  className="absolute w-[249px] h-[83px] bg-[#cdc7dd] rounded-[14px] shadow-[0px_3px_3px_#00000040]"
                  style={{
                    top: testimonial.position.top,
                    left: testimonial.position.left,
                  }}
                >
                  <img
                    className="absolute w-14 h-14 top-[13px] left-[18px] object-cover"
                    alt={`${testimonial.name} profile picture`}
                    src={testimonial.image}
                  />
                  <h3 className="absolute top-[13px] left-[85px]  font-sans  font-semibold text-black text-[11px]">
                    {testimonial.name}
                  </h3>
                  <p className="absolute w-[153px] top-[29px] left-[85px]  font-sans  text-black text-[10px]">
                    {testimonial.text}
                  </p>
                </article>
              ))}
            </div>
          </section>
        </div>
      </div>

      {/* Mobile Layout */}
<div className="block lg:hidden w-full h-screen flex justify-center items-center relative overflow-hidden">
  {/* Rounded container for background image */}
  <div className="absolute inset-0 rounded-[8px] overflow-hidden">
    <div
      className="w-full h-full bg-cover bg-no-repeat bg-center"
      style={{ backgroundImage: "url('/assets/images/backgrounds/backround.png')" }}
    />
  </div>

  {/* Scaled content container */}
  <div
    style={{
      transform: "scale(0.9)",
      transformOrigin: "center center",
      display: "inline-block",
      borderRadius: "20px",
      overflow: "hidden",
      width: "376px",
      backgroundColor: "transparent",
      position: "relative",
      zIndex: 1,
    }}
  >
    <div className="flex w-[376px] p-[10px] flex-col gap-[15px] justify-center items-center relative z-[1]">
      {/* Main Text Box */}
      <div className="w-[356px] h-[421px] rounded-[20px] opacity-90 relative z-[2]">
        <div className="flex w-[356px] h-[421px] p-[34px_26px] bg-[#fff] rounded-[20px] absolute top-0 left-0 z-[3]">
          <div className="w-[303px] h-[345px] relative z-[4]">
            <span className="flex w-[303px] h-[286px] font-sans text-[18px] leading-[21.784px] text-[#2c1734]">
              Our app uses smart technology to recommend skincare and beauty
              items based on their ingredients and how similar they are to
              products you already love.
              <br />
              <br />
              Behind the scenes, it learns from lots of data and connections
              between ingredients to suggest options you'll enjoy. It’s like
              having a beauty expert in your pocket, helping you discover new
              favourites easily and confidently.
            </span>
            <div className="w-[34px] h-[34px] bg-[url('/assets/images/icons/logo_miniature.svg')] bg-cover bg-no-repeat mt-[25px] ml-[134px]" />
          </div>
        </div>
      </div>

      {/* Beauty Expert Card */}
      <div className="h-[119px] w-full relative z-[7]">
        <div className="w-full h-full bg-[#cdc7dd] rounded-[20px]" />
        <div className="w-[22.48%] h-[67.91%] bg-[url('/assets/images/icons/male-icon.png')] bg-cover bg-no-repeat rounded-[16px] absolute top-[15.88%] left-[7.16%]" />
        <span className="flex font-sans text-[16px] font-semibold absolute top-[15.88%] left-[33.89%]">
          Beauty Expert
        </span>
        <span className="flex w-[219.414px] font-sans text-[14px] absolute top-[35.47%] left-[33.89%]">
          This app makes finding the best products by ingredients effortless
          and reliable.
        </span>
      </div>

      {/* Customer Card */}
      <div className="w-[356px] h-[118px] relative z-[12]">
        <div className="w-full h-full bg-[#cdc7dd] rounded-[20px]" />
        <div className="w-[22.48%] h-[67.91%] bg-[url('/assets/images/icons/female-icon.png')] bg-[length:100%_100%] bg-no-repeat rounded-[16px] absolute top-[15.88%] left-[7.16%]" />
        <span className="flex font-sans text-[16px] font-semibold absolute top-[15.88%] left-[33.89%]">
          Customer
        </span>
        <span className="flex w-[219.414px] font-sans text-[14px] absolute top-[35.47%] left-[33.89%]">
          I saved time searching for cosmetics and actually saw my skin improve.
        </span>
      </div>
    </div>
  </div>
</div>



      
    </div>
  );
}
